export default "__VITE_PUBLIC_ASSET__a52d9628__"